module.exports = " ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/admin/pages/Blank.vue
// module id = 280
// module chunks = 0